module.exports = __webpack_public_path__ + "img/Ticket Checking.da085052.svg";